import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Footer } from './components/Footer';
import { ProgressBarProvider } from './hooks/useProgressBar';
import ProgressBarFloating from './components/ProgressBarFloating';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ProgressBarProvider>
      <App />
      <ProgressBarFloating />
      <Footer />
    </ProgressBarProvider>
  </React.StrictMode>
);
